import type React from 'react'
import { toast } from 'react-hot-toast'

import { themeBackgroundBlurMap } from '@mntn-dev/ui-theme'
import { cn } from '@mntn-dev/ui-utilities'

import type { TestIds } from '../../utils/testing.ts'
import { IconButton } from '../buttons/icon-button.tsx'
import { Stack } from '../stack/stack.tsx'
import { Surface } from '../surface/surface.tsx'
import { Text } from '../text/text.tsx'

type ToastItemProps = TestIds & {
  message: { id: string }
  title: string
  body?: string
  icon?: React.JSX.Element
}

const ToastItem: React.FC<ToastItemProps> = ({
  dataTestId,
  dataTrackingId,
  message,
  title,
  body,
  icon,
}) => {
  return (
    <Surface
      border
      width="72"
      backgroundColor="container"
      className={cn('mr-4 select-none', themeBackgroundBlurMap['blur-lg'])}
      dataTestId={dataTestId}
      dataTrackingId={dataTrackingId}
    >
      <Stack gap="4" className="m-4">
        {icon && <div className="flex">{icon}</div>}
        <div className="flex grow flex-col">
          <Text className="font-bold">{title}</Text>
          {body && (
            <Text className="mt-1" fontSize="sm" textColor="secondary">
              {body}
            </Text>
          )}
        </div>
        <div className="flex">
          <IconButton
            name="close"
            fill="solid"
            size="lg"
            onClick={() => toast.dismiss(message.id)}
          />
        </div>
      </Stack>
    </Surface>
  )
}

export { ToastItem, type ToastItemProps }
